import { render, staticRenderFns } from "./SocialSchedule.vue?vue&type=template&id=71ce755a&scoped=true&"
import script from "./SocialSchedule.vue?vue&type=script&lang=js&"
export * from "./SocialSchedule.vue?vue&type=script&lang=js&"
import style0 from "./SocialSchedule.vue?vue&type=style&index=0&id=71ce755a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce755a",
  null
  
)

export default component.exports